// packages
import 'intersection-observer';
import yall from 'yall-js';

// utils
import { AdLoader } from '../ads/loader';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart the lazy image loading
  yall();

  // Kickstart the ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});
